<template>
  <div>
    <div id="goz_esnetme" class="asd" v-loading="loading">
      <div
        v-if="ended"
        style="
          position: absolute;
          width: 100%;
          height: 100%;
          left: 0;
          top: 0;
          background-color: #f2f2f2;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          z-index: 9;
        "
      >
        <button
          class="btn"
          style="width: 200px; margin-bottom: 30px; font-size: 30px"
          @click="
            ended = false;
            player.currentTime = 0;
            player.play();
          "
        >
          <i class="fas fa-play"></i> Tekrar İzle
        </button>
        <button
          class="btn"
          style="width: 200px; margin-bottom: 30px; font-size: 30px"
          @click="$emit('goNext')"
        >
          <i class="fas fa-arrow-right"></i> Devam Et
        </button>
      </div>
      <video
        autoplay
        style="background-color: transparent; width: 100%; height: 100%"
        :src="videoUrl"
        id="player"
      ></video>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import axios from "axios";
export default {
  props: ["config"],
  name: "Video",
  data() {
    return {
      player: null,
      videoUrl: null,
      loading: true,
      videoDuration: 0,
      ended: false,
    };
  },
  created() {
    axios
      .post("course/video", {
        bucket_name: this.config.bucket_name,
        video: this.config.video,
      })
      .then((res) => {
        this.videoUrl = res.data.data;
        this.init();
      });
  },
  mounted() {
    this.wrapper = {
      width: document.getElementById("goz_esnetme").clientWidth,
      height: document.getElementById("goz_esnetme").clientHeight,
    };
  },
  methods: {
    init() {
      this.player = new Plyr("#player");
      this.player.on("loadedmetadata", (event) => {
        setTimeout(() => {
          this.$emit("totalDurationReady", event.detail.plyr.duration);
          this.loading = false;
          this.$emit("totalDuration", event.detail.plyr.duration);
        }, 0);
      });

      this.player.on("timeupdate", (e) => {
        this.$emit("playerTimeChanged", e.detail.plyr.currentTime);
      });

      this.player.on("ended", () => {
        this.ended = true;
        this.player.fullscreen.exit();
      });
    },
  },
};
</script>

<style lang="less" scoped>
#goz_esnetme {
  width: 700px;
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 20px;
  background: transparent;
}
</style>

<style>
.asd .el-loading-mask {
  position: absolute;
  z-index: 2000;
  background-color: rgb(242 242 242);
  margin: 0;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  -webkit-transition: opacity 0.3s;
  transition: opacity 0.3s;
}
</style>


// WEBPACK FOOTER //
// src/components/modules/Video.vue